export default "__VITE_ASSET__DVOlvw1j__"